import { render } from "./MDetails3.vue?vue&type=template&id=a725daae&scoped=true"
import script from "./MDetails3.vue?vue&type=script&lang=js"
export * from "./MDetails3.vue?vue&type=script&lang=js"

import "./MDetails3.vue?vue&type=style&index=0&id=a725daae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a725daae"]])

export default __exports__